<template>
  <v-container :class="$vuetify.breakpoint.width < 1264 ? 'container-plan px-7' : 'container-plan pl-12 pr-4'">
    <v-row class="wrap-plan-type mb-0" justify="center" align="start" dense>
      <!-- <v-col v-if="!isWsOwner" cols="12" class="your-plan-title mb-4" align="start">Your Plan</v-col> -->
      <v-col
        v-for="(item, index) in productInfo"
        :key="index"
        cols="6"
        :class="index == 0 ? 'plan-type pr-5' : 'plan-type pl-5'"
        align="start"
      >
        <v-col cols="12" style="padding: 0; position: relative; margin-top: -5px">
          <div
            class="txt-your-plan"
            :style="
              isWsOwner
                ? 'opacity: 0'
                : userPlan == 'Plus' && index == 0
                ? 'opacity: 1'
                : userPlan == 'Free' && index == 1
                ? 'opacity: 1'
                : 'opacity: 0'
            "
          >
            {{ $t('yourPlan') }}
          </div>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.width < 700 ? '12' : '6'"
          :class="$vuetify.breakpoint.width < 1264 ? 'kind mb-0' : 'kind mb-0'"
          align="start"
        >
          <v-row no-gutters align="center" justify="start">
            <v-col
              cols="auto"
              :style="
                isWsOwner
                  ? ''
                  : userPlan == 'Plus' && index == 0
                  ? 'color: #25c685'
                  : userPlan == 'Free' && index == 1
                  ? 'color: #25c685'
                  : ''
              "
            >
              {{ item['name'] }}
            </v-col>
            <v-col cols="auto">
              <v-tooltip bottom nudge-top="70" nudge-right="10" color="#131b1e">
                <template v-slot:activator="{ on }">
                  <div class="kind-desc mt-3 ml-2" v-on="on">
                    <span v-if="item['default_price'].unit_amount > 0" class="kind-desc gray-text">
                      ${{ getAnnuallyPrice(item) }} / Month ⓘ
                    </span>
                  </div>
                </template>
                <span>{{ $t('payAnnuallyInfo') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <!-- <span v-if="item['default_price'].unit_amount > 0" class="kind-desc gray-text"> -->
          <!-- (${{ item['default_price'].unit_amount / 100 }} / {{ getPaymentInterval(item) }} ⓘ) -->
          <!-- (${{ getAnnuallyPrice(item) }} / Month ⓘ) -->
          <!-- </span> -->
        </v-col>
        <v-col
          v-if="isWsOwner"
          :cols="$vuetify.breakpoint.width < 700 ? '12' : '6'"
          :class="$vuetify.breakpoint.width < 1264 ? 'seat mb-2' : 'seat'"
          :align="$vuetify.breakpoint.width < 700 ? 'start' : 'end'"
        >
          {{ (index == 0 ? originData.plusSeats : originData.freeSeats) + ' Seats' }}
        </v-col>
        <v-col cols="12" class="desc gray-text" align="start">
          {{ item['name'] === 'Plus' ? $t('plusDescriptionContent1') : $t('freeDescriptionContent1') }}
        </v-col>
        <!-- <v-col cols="12" class="desc gray-text" align="start">
          {{ item['name'] === 'Plus' ? $t('plusDescriptionContent2') : $t('freeDescriptionContent2') }}
        </v-col> -->
        <v-col cols="auto" class="desc gray-text" align="start">
          {{ item['name'] === 'Plus' ? $t('plusDescriptionContent3') : $t('freeDescriptionContent3') }}
        </v-col>
        <v-col cols="auto" class="desc gray-text ml-1" style="font-size: 10px" align="start">
          {{ item['name'] === 'Plus' ? $t('plusDescriptionContent4') : $t('freeDescriptionContent4') }}
        </v-col>
      </v-col>
      <v-col
        v-if="productListLoading"
        cols="6"
        :style="
          isWsOwner
            ? 'margin-top: 14px'
            : $vuetify.breakpoint.width < 1264
            ? $vuetify.breakpoint.width < 700
              ? 'margin-top: 16px; margin-bottom: 25px'
              : 'margin-top: 16px'
            : 'margin-bottom: 14px'
        "
      >
        <v-skeleton-loader
          type="heading"
          width="100%"
          dark
          :style="
            $vuetify.breakpoint.width < 1264
              ? $vuetify.breakpoint.width < 700
                ? 'margin-bottom: 19px'
                : 'margin-top: 3px'
              : 'margin-bottom: 39px'
          "
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="paragraph"
          width="90%"
          dark
          :style="
            isWsOwner
              ? 'margin-top: 16px'
              : $vuetify.breakpoint.width < 1264
              ? 'margin-top: 25px'
              : 'margin-bottom: 0px'
          "
        ></v-skeleton-loader>
      </v-col>
      <v-col
        v-if="productListLoading"
        cols="6"
        :style="
          isWsOwner
            ? 'margin-top: 14px'
            : $vuetify.breakpoint.width < 1264
            ? $vuetify.breakpoint.width < 700
              ? 'margin-top: 16px; margin-bottom: 25px'
              : 'margin-top: 16px'
            : 'margin-bottom: 14px'
        "
      >
        <v-skeleton-loader
          type="heading"
          width="100%"
          dark
          :style="
            $vuetify.breakpoint.width < 1264
              ? $vuetify.breakpoint.width < 700
                ? 'margin-bottom: 19px'
                : 'margin-bottom: 3px'
              : 'margin-bottom: 39px'
          "
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="paragraph"
          width="90%"
          dark
          :style="
            isWsOwner
              ? 'margin-top: 16px'
              : $vuetify.breakpoint.width < 1264
              ? 'margin-top: 25px'
              : 'margin-bottom: 0px'
          "
        ></v-skeleton-loader>
      </v-col>
      <!-- <v-col cols="6" class="plan-type pl-5" align="start">
        <v-col
          :cols="$vuetify.breakpoint.width < 700 ? '12' : '6'"
          :class="$vuetify.breakpoint.width < 1264 ? 'kind mb-0' : 'kind mb-4'"
          align="start"
        >
          Free
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.width < 700 ? '12' : '6'"
          :class="$vuetify.breakpoint.width < 1264 ? 'seat mb-2' : 'seat'"
          :align="$vuetify.breakpoint.width < 1264 ? 'start' : 'end'"
        >
          {{ originData.freeSeats + ' Seats' }}
        </v-col>
        <v-col cols="12" class="desc gray-text" align="start">
          25 Videos / Person
          <br />
          5 min / Video
        </v-col>
      </v-col> -->
    </v-row>
    <v-row justify="center" align="center" class="wrap-plan-link mt-5" dense>
      <v-col cols="12" align="center">
        <a href="https://www.tape.ooo/pricing" target="_blank">
          <div class="text-decoration-underline link-text">{{ $t('seeFeatureBenefit') }}</div>
        </a>
      </v-col>
    </v-row>
    <v-row class="wrap-change-plan mt-2 mb-5" justify="center" align="center" dense>
      <v-col :cols="isWsOwner ? 6 : 12" class="change-plan-title" align="start">{{ $t('changePlan') }}</v-col>
      <v-col v-if="isWsOwner" cols="6" class="mark-all-as-plus" align="end">
        <div class="text-decoration-underline accent-text pointer" @click="markallasplus">
          {{ $t('markAllasPlus') }}
        </div>
      </v-col>
      <v-card v-if="isWsOwner" class="warp-change-plan-list mt-2" dark>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="list-item-avatar"
          width="50%"
          dark
          class="mb-1"
          style="display: inline-block"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="button"
          dark
          class="mt-1 mr-3"
          style="display: inline-block; float: right"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="list-item-avatar"
          width="50%"
          dark
          class="mb-1"
          style="display: inline-block"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="button"
          dark
          class="mt-1 mr-3"
          style="display: inline-block; float: right"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="list-item-avatar"
          width="50%"
          dark
          class="mb-1"
          style="display: inline-block"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="button"
          dark
          class="mt-1 mr-3"
          style="display: inline-block; float: right"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="list-item-avatar"
          width="50%"
          dark
          class="mb-1"
          style="display: inline-block"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="wsMemberLoading"
          type="button"
          dark
          class="mt-1 mr-3"
          style="display: inline-block; float: right"
        ></v-skeleton-loader>
        <v-row v-for="(item, index) in dummyData.memberList" :key="index" class="pt-1 pl-3" dense align="center">
          <v-col cols="auto">
            <!-- <v-avatar round size="40" class="mr-3">
              <v-img :src="item.userPicture" />
            </v-avatar> -->
            <v-avatar
              v-if="item"
              :color="!item.userPicture ? item.userDisplayName || item.userFullName : '' | iconBackground"
              class="mr-2"
              round
              size="30"
            >
              <div class="avatar-bg" v-if="item.userPicture"></div>
              <span class="white--text text-h6 cent" style="font-size: 14px !important" v-if="!item.userPicture">
                {{ item.userDisplayName || item.userFullName | iconFilter }}
              </span>
              <v-img :src="item.userPicture" v-else />
            </v-avatar>
          </v-col>
          <v-col class="text-truncate pr-2" style="margin-top: -5px">
            <span style="vertical-align: sub; font-size: 15px">{{ item.userDisplayName || item.userFullName }}</span>
          </v-col>
          <v-spacer v-if="$vuetify.breakpoint.width >= 1264" />
          <v-col cols="auto" align="end">
            <!-- <v-menu offset-y dark> -->
            <!-- <template v-slot:activator="{ on, attrs }"> -->
            <v-switch
              dark
              :class="
                $vuetify.breakpoint.width < 1264 ? 'change-plan-list-btn pl-3 pr-1' : 'change-plan-list-btn pl-8 pr-3'
              "
              :color="item.planType == 'Plus' ? 'rgb(40, 144, 103)' : '#777'"
              v-model="item.planType"
              true-value="Plus"
              false-value="Free"
              @change="changePlanType(item.planType, index)"
              :label="`${item.planType ? item.planType : 'Free'}`"
            >
              <!-- {{ item.plan }} -->
              <!-- <span class="material-icons-round ml-1" style="color: #fff; font-size: 20px; cursor: pointer">
                  arrow_drop_down
                </span> -->
            </v-switch>
            <!-- </template>
              <v-list>
                <v-list-item v-for="(item, i) in plans" :key="i">
                  <v-list-item-title class="change-plan-list-name" @click="changePlanType($event, index)">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list> -->
            <!-- </v-menu> -->
          </v-col>
        </v-row>
      </v-card>
    </v-row>
    <v-row v-if="!wsMemberLoading && !isWsOwner" class="no-admin-desc" dense justify="center" align="center">
      <v-col cols="12" align="center">{{ $t('askAdminInfo') + ' - ' + nameWsOwner }}</v-col>
      <v-col cols="12" align="center">
        <v-btn
          dark
          color="rgb(40, 144, 103)"
          elevation="0"
          class="mt-3 px-15"
          style="border-radius: 15px"
          @click="requestUpgradePlan"
        >
          {{ $t('requestAdmin') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="wsMemberLoading && !isWsOwner" dense justify="center" align="center">
      <v-col cols="8" align="center">
        <v-skeleton-loader type="text" dark style="margin-top: 15px !important"></v-skeleton-loader>
      </v-col>
      <v-col cols="12" align="center">
        <v-skeleton-loader type="button" dark style="margin-top: 10px !important"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row
      v-if="isWsOwner && JSON.stringify(dummyData) !== JSON.stringify(originData)"
      :style="
        JSON.stringify(originData) == JSON.stringify(dummyData)
          ? 'opacity: 0; transition: all 0s; height: 0'
          : 'opacity: 1; transition: all 0.3s; height: auto'
      "
      justify="center"
      align="center"
      dense
    >
      <v-col class="wrap-summary">
        <v-col :cols="$vuetify.breakpoint.width < 700 ? '12' : '12'" class="summary-title">
          {{ $t('summaryOfChanges') }}
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.width < 700 ? '12' : '6'"
          class="summary-price"
          :style="$vuetify.breakpoint.width < 700 ? 'padding: 8px 0 0 12px !important' : ''"
        >
          <span
            v-if="
              !productListLoading &&
              selectedWsInfo.stripeSubId &&
              JSON.stringify(dummyData) !== JSON.stringify(originData)
            "
            style="text-decoration: line-through"
          >
            {{ '$' + originData.plusSeats * amount }}
          </span>
          <span
            v-if="
              !productListLoading &&
              selectedWsInfo.stripeSubId &&
              JSON.stringify(dummyData) !== JSON.stringify(originData)
            "
            class="ml-1"
            style="font-weight: 400; font-size: 21px; vertical-align: top"
          >
            {{ '->' }}
          </span>
          <span v-if="!productListLoading">
            {{ '$' + (selectedWsInfo.stripeSubId ? dummyData.plusSeats * amount : dummyData.plusSeats * unitAmount) }}
          </span>
          <span v-if="!productListLoading" class="per-month">
            {{ '/ ' + (selectedWsInfo.stripeSubId ? interval : 'month') }}
          </span>
          <span v-if="!productListLoading" class="gray-text ml-1" style="font-size: 12px; font-weight: 400">
            {{
              '($' +
              (selectedWsInfo.stripeSubId ? amount : unitAmount) +
              ' / seat / ' +
              (selectedWsInfo.stripeSubId ? interval : 'month') +
              ')'
            }}
          </span>
          <v-skeleton-loader
            v-else
            :class="$vuetify.breakpoint.width < 1264 ? ($vuetify.breakpoint.width < 700 ? 'mt-2' : 'mt-4') : 'mt-3'"
            :width="$vuetify.breakpoint.width < 700 ? '50%' : ''"
            type="text"
            dark
          ></v-skeleton-loader>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.width < 700 ? 12 : 6" style="display: inline-block; padding: 0">
          <v-col
            :cols="$vuetify.breakpoint.width < 700 ? '12' : '12'"
            :align="$vuetify.breakpoint.width < 700 ? 'start' : 'end'"
            :class="$vuetify.breakpoint.width < 700 ? 'summary-change-seats ml-4' : 'summary-change-seats'"
          >
            <span v-if="!productListLoading" class="summary-subtitle mr-2">Plus</span>
            <span v-if="!productListLoading" class="gray-text mr-1" style="text-decoration: line-through">
              {{ originData.plusSeats + ' Seats' }}
            </span>
            <span v-if="!productListLoading" class="gray-text">{{ '->' }}</span>
            <span v-if="!productListLoading" class="" style="font-weight: 600">
              {{ dummyData.plusSeats + ' Seats' }}
            </span>
            <span v-if="!productListLoading" class="accent-text" style="font-weight: 600">
              {{
                '(' +
                (dummyData.plusSeats - originData.plusSeats > -1 ? '+' : '') +
                (dummyData.plusSeats - originData.plusSeats) +
                ')'
              }}
            </span>
            <v-skeleton-loader
              v-else
              :class="$vuetify.breakpoint.width < 1264 ? 'mt-1' : 'mt-3'"
              :width="$vuetify.breakpoint.width < 700 ? '50%' : ''"
              type="text"
              dark
            ></v-skeleton-loader>
          </v-col>
          <!-- <v-col
            :cols="$vuetify.breakpoint.width < 700 ? '12' : '6'"
            :style="$vuetify.breakpoint.width < 700 ? 'padding: 0 0 10px 12px !important' : ''"
            :align="$vuetify.breakpoint.width < 700 ? 'start' : 'end'"
            :class="$vuetify.breakpoint.width < 700 ? 'summary-change-seats ml-4' : 'summary-change-seats'"
          >
            <span v-if="!productListLoading" class="summary-subtitle mr-2">Free</span>
            <span v-if="!productListLoading" class="gray-text">{{ originData.freeSeats + ' Seats -> ' }}</span>
            <span v-if="!productListLoading" class="accent-text">
              {{ dummyData.freeSeats + ' Seats' }}
            </span>
            <v-skeleton-loader
              v-else
              :class="$vuetify.breakpoint.width < 1264 ? 'mt-1' : 'mt-3'"
              :width="$vuetify.breakpoint.width < 700 ? '50%' : ''"
              type="text"
              dark
              :style="$vuetify.breakpoint.width < 700 ? 'padding-top: 0px' : 'padding-top: 3px'"
            ></v-skeleton-loader>
          </v-col> -->
        </v-col>
      </v-col>
    </v-row>
    <v-row class="mt-8 mb-5 pr-2" justify="end">
      <v-btn v-if="isWsOwner" class="btn-cancel" color="#777" dark @click="close">{{ $t('cancel') }}</v-btn>
      <v-btn
        v-if="isWsOwner && (!selectedWsInfo['stripeSubId'] || selectedWsInfo['stripeSubId'] === '')"
        class="btn-confirm ml-2"
        color="rgb(40, 144, 103)"
        dark
        :loading="createSubscriptionLoading"
        :disabled="JSON.stringify(originData) == JSON.stringify(dummyData)"
        @click="setPayment"
      >
        {{ $t('upgrade') }}
      </v-btn>
      <v-btn
        v-else-if="isWsOwner && selectedWsInfo['stripeSubId'] && selectedWsInfo['stripeSubId'] !== ''"
        class="btn-confirm ml-2"
        color="rgb(40, 144, 103)"
        dark
        :loading="updateSubscriptionLoading"
        :disabled="JSON.stringify(originData) == JSON.stringify(dummyData)"
        @click="updateSubscription"
      >
        {{ $t('update') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { getWsMember } from '@/services/api'
import { getStripePaymentUrl, updateSubscription, getProductList, requestUpgradePlan } from '@/services/stripe'
import { mapGetters } from 'vuex'

export default {
  name: 'PlanSetting',
  data() {
    return {
      loading: false,
      wsMemberLoading: false,
      productListLoading: false,
      createSubscriptionLoading: false,
      updateSubscriptionLoading: false,
      plans: [{ title: 'Plus' }, { title: 'Free' }],
      productInfo: [],
      originData: {
        plusSeats: 0,
        freeSeats: 0,
        memberList: [],
      },
      dummyData: {},
      interval: '',
      amount: '',
      priceId: null,
    }
  },
  computed: {
    ...mapGetters(['selectedWsInfo', 'isWsOwner', 'isWsManager', 'userInfo', 'wsClipCnt']),
    nameWsOwner() {
      let WsOwner
      for (let i = 0; i < this.originData.memberList.length; i++) {
        if (this.originData.memberList[i].userId == this.selectedWsInfo.wsCreatedUid) {
          WsOwner = this.originData.memberList[i].userDisplayName || this.originData.memberList[i].userFullName
        }
      }
      return WsOwner
    },
    userPlan() {
      const userId = this.userInfo.userId
      let userPlan
      for (let i = 0; i < this.originData.memberList.length; i++) {
        if (this.originData.memberList[i].userId == userId) {
          userPlan = this.originData.memberList[i].planType
        }
      }
      return userPlan
    },
    unitAmount() {
      let amount = 0
      if (this.productInfo && this.productInfo.length > 0) {
        let priceList = this.productInfo[0].priceList
        if (priceList && priceList.length > 0) {
          let price = priceList.find((price) => price['active'] === true && price['recurring']['interval'] === 'month')
          amount = price['unit_amount'] / 100
        }
      }
      return amount
    },
  },
  created() {
    this.getWsMember()
    this.getProductList()
  },
  methods: {
    getAnnuallyPrice(item) {
      let annuallyPrice = 0
      if (item && item['priceList'] && item['priceList'].length > 0) {
        let price = item['priceList'].find(
          (price) => price['active'] === true && price['recurring']['interval'] === 'year'
        )
        if (price) annuallyPrice = price['unit_amount'] / 100 / 12
        else annuallyPrice = item['default_price'].unit_amount / 100
      }
      return annuallyPrice
    },
    getPaymentInterval(product) {
      let value = ''
      let txt = product['default_price']['recurring']['interval']
      if (txt && txt !== '') value = txt.charAt(0).toUpperCase() + txt.slice(1)
      return value
    },
    async getProductList() {
      try {
        this.productListLoading = true
        let response = await getProductList(this, this.selectedWsInfo['stripeSubId'])
        // this.productInfo = response['result']['data']
        // console.log('response ', response)
        let pluspProduct = response['itemList'].find((product) => product['name'] === 'Plus')
        let freeProduct = response['itemList'].find((product) => product['name'] === 'Free')
        if (response['subscriptionPlan']) {
          this.interval = response['subscriptionPlan'].interval
          this.amount = response['subscriptionPlan'].amount / 100
          this.priceId = response['subscriptionPlan']['id']
        }
        this.productInfo = [pluspProduct, freeProduct]
        // console.log('productInfo : ', this.productInfo)
      } catch (error) {
        console.log('error ', error)
      } finally {
        this.productListLoading = false
      }
    },
    async setPayment() {
      // let url = window.location.href

      let product = this.productInfo.find((product) => product['name'] === 'Plus')
      let plusMemberLength = 0
      let plusMemeberList = []
      for (let i = 0; i < this.dummyData.memberList.length; i++) {
        if (this.dummyData.memberList[i].planType) {
          if (this.dummyData.memberList[i].planType == 'Plus') {
            plusMemberLength++
            plusMemeberList.push({
              userId: this.dummyData.memberList[i].userId,
              planType: 'Plus',
            })
          }
        }
      }
      try {
        this.createSubscriptionLoading = true

        let successUrl = `${location.origin}/payment-result?result=success&wsDomain=${this.selectedWsInfo['wsDomain']}`
        let failUrl = `${location.origin}/payment-result?result=fail&wsDomain=${this.selectedWsInfo['wsDomain']}`

        // let successUrl = 'https://app.tape.ooo/signin'
        // let failUrl = 'https://app.tape.ooo/signin'

        let result = await getStripePaymentUrl(
          this,
          this.selectedWsInfo['wsId'],
          this.selectedWsInfo['wsDomain'],
          this.userInfo['userEmail'],
          this.priceId ?? product['default_price']['id'],
          plusMemberLength,
          plusMemeberList,
          successUrl,
          failUrl
        )
        location.replace(result['url'])

        // notify(this, 'Success', this.$t('updateSuccess'), 'success')
      } catch (error) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        console.log('create new subscription error : ', error)
      } finally {
        this.getWsMember()
        this.getProductList()
        this.createSubscriptionLoading = false
      }
    },
    async updateSubscription() {
      // 'sub_1MWMGyJx48egp9kgyR9znI5x'

      let plusMemberQuantity = 0
      let changedMemeberList = []
      if (this.dummyData && this.dummyData['memberList'] && this.dummyData['memberList'].length > 0) {
        for (let member of this.dummyData['memberList']) {
          if (member.planType && member.planType === 'Plus') {
            plusMemberQuantity++
          }
          let originMember = this.originData.memberList.find((value) => value.userId === member.userId)
          if (originMember.planType !== member.planType) {
            changedMemeberList.push({
              userId: member.userId,
              planType: member.planType,
            })
          }
        }

        // 구독 변동된 유저가 있는 경우에만 실행
        if (changedMemeberList && changedMemeberList.length > 0) {
          let product = this.productInfo.find((product) => product['name'] === 'Plus')
          try {
            this.updateSubscriptionLoading = true

            await updateSubscription(
              this,
              this.selectedWsInfo['wsId'],
              this.selectedWsInfo['wsDomain'],
              this.selectedWsInfo['stripeSubId'],
              this.priceId ?? product['default_price']['id'],
              plusMemberQuantity,
              changedMemeberList
            )

            let freeSeats = 0
            let plusSeats = 0
            // 업데이트 후 refresh 없이 로컬에서 origin data도 업데이트 해준다.
            for (let member of this.originData['memberList']) {
              let changedMember = changedMemeberList.find((changedUser) => changedUser['userId'] === member['userId'])
              if (changedMember) {
                member['planType'] = changedMember['planType']
                if (this.userInfo['userId'] === changedMember['userId'])
                  this.wsClipCnt['planType'] = changedMember['planType']
              }

              // Free, Plus seats 변경
              if (member['planType'] === 'Plus') plusSeats++
              else freeSeats++
            }

            this.originData.freeSeats = freeSeats
            this.originData.plusSeats = plusSeats

            // notify(this, 'Success', this.$t('updateSuccess'), 'success')
            const content = {
              component: Toast,
              props: {
                msg: this.$t('updateSuccess'),
                // submsg: '',
              },
            }
            this.$toast.success(content)
          } catch (error) {
            // notify(this, 'Error', this.$t('general.error'), 'error')
            const content = {
              component: Toast,
              props: {
                msg: this.$t('general.error'),
                // submsg: '',
              },
            }
            this.$toast.error(content)
            console.log('update subscription error : ', error)
          } finally {
            // this.getWsMember()
            // this.getProductList()
            this.updateSubscriptionLoading = false
          }
        }
      }
    },
    async getWsMember() {
      try {
        this.wsMemberLoading = true
        let result = await getWsMember(this, this.selectedWsInfo['wsId'])
        this.dummyData = { ...this.originData }
        this.originData['memberList'] = []
        this.dummyData['memberList'] = []

        let freeSeats = 0
        let plusSeats = 0

        for (let member of result) {
          if (!member['planType'] || member['planType'] === '') member['planType'] = 'Free'
          if (member['planType'] === 'Free') freeSeats++
          else if (member['planType'] === 'Plus') plusSeats++
          this.originData['memberList'].push(Object.assign({}, member))
          this.dummyData['memberList'].push(Object.assign({}, member))
        }
        this.originData['freeSeats'] = freeSeats
        this.originData['plusSeats'] = plusSeats
        this.dummyData['freeSeats'] = freeSeats
        this.dummyData['plusSeats'] = plusSeats
      } catch (error) {
        console.log('error ', error)
      } finally {
        this.wsMemberLoading = false
      }
    },
    async requestUpgradePlan() {
      try {
        await requestUpgradePlan(this, this.selectedWsInfo['wsId'], this.userInfo.userId)
        // notify(this, 'Success', this.$t('emailAdminUpgrade'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('emailAdminUpgrade'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      } catch (error) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        console.log('error ', error)
      }
    },
    changePlanType(e, index) {
      this.dummyData.memberList[index].planType = e
      this.calcutatePlanType()
    },
    markallasplus() {
      for (let i = 0; i < this.dummyData.memberList.length; i++) {
        this.dummyData.memberList[i].planType = 'Plus'
      }
      this.calcutatePlanType()
    },
    calcutatePlanType() {
      let changedPlus = 0
      let changedFree = 0

      for (let i = 0; i < this.dummyData.memberList.length; i++) {
        if (this.dummyData.memberList[i].planType == 'Plus') {
          changedPlus++
        } else if (this.dummyData.memberList[i].planType == 'Free') {
          changedFree++
        }
      }

      this.dummyData.plusSeats = changedPlus
      this.dummyData.freeSeats = changedFree
    },
    close() {
      this.$emit('close', 'Setting')
    },
  },
  watch: {
    // loading: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     console.log(this.loading)
    //   },
    // },
  },
}
</script>

<style scoped>
.container-plan {
  position: relative;
  background-color: #21343b;
  /* height: 650px; */
}
/* @media (max-width: 1264px) {
  .container-plan {
    height: 850px;
  }
} */
.wrap-plan-type {
  width: 100%;
}
.plan-type {
  display: inline-block;
  color: #eee;
  padding: 0;
}
.plan-type .kind {
  display: inline-block;
  font-size: 30px;
  font-weight: 700;
  padding: 0;
}
@media (max-width: 1264px) {
  .plan-type .kind {
    font-size: 24px;
  }
}
@media (max-width: 700px) {
  .plan-type .kind {
    font-size: 17px;
  }
}
.plan-type .seat {
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  padding: 0;
}
@media (max-width: 700px) {
  .plan-type .seat {
    font-size: 16px;
  }
}
.plan-type .kind-desc {
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
}
@media (max-width: 1264px) {
  .plan-type .kind-desc {
    font-size: 10px;
  }
}
.plan-type .desc {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  padding: 0;
}
@media (max-width: 1264px) {
  .plan-type .desc {
    font-size: 13px;
  }
}
.plan-type .txt-your-plan {
  position: relative;
  display: inline-block;
  font-size: 11px;
  font-weight: 400;
  background-color: #111a1e;
  border-radius: 5px;
  padding: 2px 7px;
  margin-bottom: 3px;
}
.wrap-plan-link {
  display: block;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
}
.change-plan-title,
.your-plan-title {
  display: inline-block;
  font-size: 18px;
  font-weight: 700;
  color: #eee;
}
@media (max-width: 700px) {
  .change-plan-title,
  .your-plan-title {
    font-size: 15px;
  }
}
.mark-all-as-plus {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
}
.warp-change-plan-list {
  width: 100%;
  height: 240px;
  background-color: #111a1e;
  border-radius: 10px !important;
  padding: 10px;
  color: #eee;
  overflow-y: auto;
}
.change-plan-list-btn {
  padding: 0;
  margin: 0;
}
.change-plan-list-btn >>> label {
  font-size: 14px;
  font-weight: 500;
  color: #ccc;
  border: 1px solid #777;
  border-radius: 5px;
  /* background-color: rgba(255, 255, 255, 0.1); */
  padding: 2px 5px;
  margin-left: 5px;
}
.change-plan-list-btn.v-input--is-label-active >>> label {
  color: rgb(40, 144, 103);
  border: 1px solid rgb(40, 144, 103);
}
.change-plan-list-btn >>> .v-messages {
  display: none;
}
.change-plan-list-name {
  color: #eee;
  font-size: 14px;
  cursor: pointer;
}
.no-admin-desc {
  color: #96a7af;
  font-weight: 400;
  font-size: 14px;
}
.wrap-summary {
  color: #eee;
  border: 1px solid #96a7af;
  border-radius: 10px;
  padding: 2px 5px;
}
.summary-title {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding-bottom: 0;
}
.summary-price {
  display: inline-block;
  font-size: 22px;
  font-weight: 600;
}
.summary-price .per-month {
  display: inline-block;
  font-size: 18px;
  font-weight: 400;
}
.summary-subtitle {
  font-weight: 600;
}
.summary-change-seats {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
}
.accent-text,
.link-text {
  color: #25c685;
}
.gray-text {
  color: #96a7af;
}
/* .v-skeleton-loader >>> div {
  background-color: transparent !important;
} */
</style>
